import React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import useBreadcrumbs from './useBreadcrumbs';

import './Breadcrumbs.scss';

const useStyles = makeStyles((theme) => ({ link: { color: theme.palette.secondary.main } }));

const Breadcrumbs = () => {
  const { breadcrumbs } = useBreadcrumbs();
  const styles = useStyles();
  const breadcrumbLink = classNames('Breadcrumbs__link', 'Breadcrumbs--text', styles.link);

  return (
    <div className="Breadcrumbs">
      <MuiBreadcrumbs
        aria-label="breadcrumb"
        separator={<span className="Breadcrumbs__separator">/</span>}
        maxItems={5}
        itemsAfterCollapse={2}
      >
        {breadcrumbs.map((crumb) => (
          <Link className={breadcrumbLink} key={crumb.url} to={crumb.url} title={crumb.label}>
            {crumb.label}
          </Link>
        ))}
      </MuiBreadcrumbs>
    </div>
  );
};

export default Breadcrumbs;
